import styled from 'styled-components';
import { breakpoint } from 'styled-components-breakpoint';

export const LogoImage = styled.img`
  ${breakpoint('mobile', 'desktop')`
    width: 160px;
    height: 38px;
  `}
`;
